<template>
  <v-app>
    <router-view></router-view>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    computed: {
      ...mapGetters("overlay", ['overlay'])
    },
  }
</script>

<style lang="scss">
  body {
    min-width: 320px;
  }
</style>
